import { render } from "./RegisterComp.vue?vue&type=template&id=4726b67e&scoped=true"
import script from "./RegisterComp.vue?vue&type=script&lang=js"
export * from "./RegisterComp.vue?vue&type=script&lang=js"

import "./RegisterComp.vue?vue&type=style&index=0&id=4726b67e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4726b67e"]])

export default __exports__